import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import type { Widget } from '../shared/types';
import type { GetWidgetTimelineRequestParams } from './types';

export const getWidgetTimeline = async <T = Widget>(
	isApp: GetWidgetTimelineRequestParams['isApp'] = false
): Promise<AxiosResponse<T[]>> => {
	return api.get<T[]>('/cityzens/widgets', {
		params: isApp ? { channel: 'App' } : undefined,
	});
};
